export const APISettings = {
    headers: new Headers({
        'Accept': 'application/json'
    }),
    baseURL: '', // TODO: update this for prod (note MBL: made this relative so that it works for the demo, but we need a better solution)
}